import type { ArenaStatId } from './arenaWeapons';

export type ArenaChallengeId = 'standard' | 'no-regeneration';

export interface ArenaChallengeRules {
  excludedDraftStats: readonly ArenaStatId[];
}

export interface ArenaChallengeDefinition {
  id: ArenaChallengeId;
  name: string;
  description: string;
  version: number;
  available: boolean;
  rules: ArenaChallengeRules;
}

export const DEFAULT_ARENA_CHALLENGE_ID: ArenaChallengeId = 'standard';

export const ARENA_CHALLENGES: readonly ArenaChallengeDefinition[] = Object.freeze([
  Object.freeze({
    id: 'standard',
    name: 'Standard',
    description: 'The classic Arena rules.',
    version: 1,
    available: true,
    rules: Object.freeze({ excludedDraftStats: Object.freeze([]) }),
  }),
  Object.freeze({
    id: 'no-regeneration',
    name: 'No Regeneration',
    description: 'Regeneration is never offered. Survive without healing.',
    version: 1,
    available: true,
    rules: Object.freeze({ excludedDraftStats: Object.freeze(['regen'] as ArenaStatId[]) }),
  }),
] satisfies ArenaChallengeDefinition[]);

export function arenaChallenge(id: string): ArenaChallengeDefinition | undefined {
  return ARENA_CHALLENGES.find((challenge) => challenge.id === id);
}

export function availableArenaChallenge(id: string | undefined): ArenaChallengeDefinition | undefined {
  return arenaChallenge(id ?? DEFAULT_ARENA_CHALLENGE_ID)?.available
    ? arenaChallenge(id ?? DEFAULT_ARENA_CHALLENGE_ID)
    : undefined;
}

/** Capture a run-owned copy so a later registry deployment cannot retune a live run. */
export function captureArenaChallenge(def: ArenaChallengeDefinition): ArenaChallengeDefinition {
  return {
    ...def,
    rules: { excludedDraftStats: [...def.rules.excludedDraftStats] },
  };
}
